export default __webpack_public_path__ + "static/media/coming-soon-image.6232912c.png";